export const WIDGETS = {
    CARDS_ASSET_INFO: 'cards_asset_info',
    GRADIENT_CARDS_ASSET_INFO: 'gradient_cards_asset_info',
    GRADIENT_CARDS_ICON: 'gradient_cards_icon',
    GRADIENT_CARDS_NAME_ICON: 'gradient_cards_name_icon',
    TWO_COLUMNS: 'two_columns',
    TWO_ICONS_ROWS: 'two_icons_rows',
}

export const WIDGET_ATTRIBUTES = {
    ASSET_CLASS: 'asset_class',
}
